import { OrderDetailProductChangeAvailabilityFareDescriptionDetailView } from "./order-detail-product-change-availability-fare-description-detail.view";

export class OrderDetailProductChangeAvailabilityFareDescriptionView {

    priceClassId: string;  
    details: OrderDetailProductChangeAvailabilityFareDescriptionDetailView[]
    more: any[];
}